import { IFloor } from "@types";
import { BaseAPI } from "@utils";

class FloorApi extends BaseAPI<IFloor> {}

export const floorApi = new FloorApi("/api/v1/floor");
